import authService from "@/services/auth";
import { CheckUserPayload } from "@/services/auth/type";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

function useMutateCheckUser() {
  const navigate = useNavigate();
  const {
    mutate: checkUser,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: (command: CheckUserPayload) => {
      return authService.checkUser(command);
    },
    onSuccess: (data, variables) => {
      if (data === true) {
        navigate("/auth/verification", {
          state: {
            phoneNumber: variables.username,
          },
        });
      } else {
        navigate("/auth/signup", {
          state: {
            phoneNumber: variables.username,
          },
        });
      }
    },
  });
  return { checkUser, isLoading, isSuccess };
}

export default useMutateCheckUser;
